import { oidcAuthReducer } from './OidcAuthReducer';

import * as medicalInsurances from '../reducers/MedicalInsuranceReducer';
import * as medicalInsurancePlans from '../reducers/MedicalInsurancePlansReducer';
import * as medicalServices from '../reducers/MedicalServicesReducer';
import * as medicalInsuranceAgreements from '../reducers/MedicalInsuranceAgreementsReducer';
import * as configuration from '../reducers/ConfigurationReducer';
import * as priceDetails from '../reducers/PriceListDetailsReducer';
import * as priceList from '../reducers/PriceListReducer';
import * as practitionerContracts from '../reducers/PractitionerContractReducer';
import * as tenantPriceLists from '../reducers/TenantPriceListReducer';
import * as agreementServices from '../reducers/AgreementServicesReducer';
import * as Practitioner from './PractitionerReducer/Practitioner.CombineReducer';
import * as Provider from '../reducers/ProviderReducer';
import * as ProviderMedicalServiceAssociation from '../reducers/ProviderMedicalServiceAssociation.Reducer';
import * as ProviderPriceListAssociation from '../reducers/ProviderPriceListAssociation.Reducer';
import * as Sponsor from '../reducers/SponsorReducer';
import * as AgreementServiceDetails from '../reducers/AgreementServiceDetailsReducer';
import * as PractitionerMedicalInsuranceAssociations from '../reducers/PractitionerMedicalInsuranceAssociation.Reducer';
import * as PractitionerSpecialtyAssociations from '../reducers/PractitionerSpecialtyAssociation.Reducer';
import * as PractitionerMedicalServiceAssociations from '../reducers/PractitionerMedicalserviceAssociation.Reducer';
import * as PractitionerSettingsReducer from './PractitionerSettings.Reducer';
import * as ProfessionalAvailabilityReducer from './ProfessionalAvailabilityReducer';
import * as MedicalProtocolReducer from './MedicalProtocol.CombineReducer';
import * as ContractCombine from './ContractReducer/Contract.CombineReducer';
// Contract sub-reducers are now consolidated under ContractReducer/CombinedContractReducer
import * as SettlementReducer from './SettlementReducer/Settlement.CombineReducer';
import * as ProtocolPractitionerReducer from './ProtocolPractitionerReducer';
import * as LanguageReducer from './LanguajeReducer';
import * as UserSettingsReducer from './UserSettingsReducer';
import * as ProceduresReducer from './ProceduresReducer';
import * as PractitionerProtocolVisitsReducer from './PractitionerProtocolVisitsReducer';
import * as ProtocolVisitsReducer from './ProtocolVisitsReducer';
import * as ProtocolPatientsReducer from './ProtocolPatientsReducer';
import * as CashFlowPaymentsReducer from './CashFlow-Payments.Reducer';
import * as CashFlowPaymentImputationsReducer from './CashFlow-PaymentImputations.Reducer';import ContractCommissionAgentConceptReducer from './ContractCommissionAgentConceptReducer';import * as CashFlowAccountsReducer from './CashFlow-Accounts.Reducer';
import * as CashFlowAccountMovementsReducer from './CashFlow-AccountMovements.Reducer';
import * as CashFlowDebtsReducer from './CashFlow-Debt.Reducer';
import * as CashFlowDebtMovementsReducer from './CashFlow-DebtMovements.Reducer';
import * as CashFlowStatisticsReducer from './CashFlow-Statistics.Reducer';
import * as SpecialtiesReducer from './Specialties.Reducer';
import * as SnomedReducer from './Snomed.Reducer';
import * as PersonsReducer from './PersonReducer';
import * as StaffReducer from './StaffReducer';
import * as PersonAddressesReducer from './PersonAddresses.Reducer';
import * as PersonEmailsReducer from './PersonEmails.Reducer';
import * as PersonPhonesReducer from './PersonPhones.Reducer';
import * as PersonIdentifiersReducer from './PersonIdentifiers.Reducer';
import * as PersonIdentifierTypesReducer from './PersonIdentifierTypes.Reducer';
import * as PersonPreferencesReducer from './PersonPreferences.Reducer';
import * as PersonRelationshipsReducer from './PersonRelationships.Reducer';
import * as PersonRelationshipTypesReducer from './PersonRelationshipTypes.Reducer';
import * as PersonExternalAssociationsReducer from './PersonExternalAssociations.Reducer';
import * as UserReducer from './Users.Reducer';
import * as fileUploadReducer from './fileUploadReducer';
import * as visitConceptsReducer from './VisitConcepts.Reducer';
import * as ContractConceptRelationship from './ContractConceptRelationshipReducer/ContractConceptRelationship.CombineReducer';
import * as ContractIAImportReducer from './ContractIAImportReducer/ContractIAImport.CombineReducer';
import ProtocolConsumptionSyncAnalysisReducer from './ProtocolConsumptionSyncAnalysisReducer/ProtocolConsumptionSyncAnalysis.Reducer';
import ConsumerBaseReducer from './ConsumerReducer/Consumer.Base.Reducer';
import ServiceBaseReducer from './ServiceReducer/Service.Base.Reducer';
import ServiceCategoryBaseReducer from './ServiceCategoryReducer/ServiceCategory.Base.Reducer';
import * as ContractBranchReducer from './ContractBranchReducer/Contract.Branches.CombineReducer';
import * as ContractConceptReducer from './ContractConceptReducer/Contract.Concept.CombineReducer';
import * as ContractStageCyclesReducer from './ContractReducer/Contract.StageCycles.Reducer';
import * as TurneroReducer from './Turnero/Turnero.CombineReducer';

// states
import * as medicalInsuranceState from '../states/MedicalInsuranceState';
import * as medicalInsurancePlansState from '../states/MedicalInsurancePlanState';
import * as medicalInsuranceAgreementsState from '../states/MedicalInsuranceAgreementState';
import * as medicalServicesState from '../states/MedicalServicesState';
import * as configurationState from '../states/ConfigurationState';
import * as priceDetailsState from '../states/PriceListDetailsState';
import * as priceListState from '../states/PriceListState';
import * as practitionerContractsState from '../states/PractitionerContractState';
import * as tenantPriceListsState from '../states/TenantPriceListState';
import * as agreementServiceState from '../states/AgreementServicesState';
import * as PractitionerState from '../states/PractitionerState';
import * as ProviderState from '../states/ProviderState';
import * as ProviderMedicalServiceAssociationState from '../states/ProviderMedicalServiceState';
import * as ProviderPriceListAssociationState from '../states/ProviderPriceListState';
import * as SponsorState from '../states/SponsorState';
import * as AgreementServiceDetailsState from '../states/AgreementServiceDetailsState';
import * as PractitionerMedicalInsuranceAssociationsState from '../states/PractitionerMedicalInsuranceState';
import * as PractitionerSpecialtyAssociationsState from '../states/PractitionerSpecialtyAssociationState';
import * as PractitionerMedicalServiceAssociationsState from '../states/PractitionerMedicalServiceState';
import * as PractitinerSettingsState from '../states/PractitionerSettingsState';
import * as ProfessionalAvailabilityState from '../states/ProfessionalAvailabilityState';
import * as MedicalProtocolState from '../states/MedicalProtocolsState';
import * as ContractState from '../states/ContractState';
import * as ContractAccessState from '../states/ContractAccess.State';
import * as ContractAddendumState from '../states/ContractAddendum.State';
import * as ContractConceptState from '../states/ContractConceptState';
import * as ContractConceptPaymentScheduleState from '../states/ContractConceptPaymentScheduleState';
import * as ContractStageCycleState from '../states/ContractStageCycleState';
import * as ContractStageTypesState from '../states/ContractStageTypes.State';
import * as ContractConceptConceptState from '../states/ContractConceptConceptState';
import * as ContractStageState from '../states/ContractStageState';
import * as SettlementState from '../states/SettlementState';
import * as ProtocolPractitionerState from '../states/ProtocolPractitionersState';
import * as LanguajeState from '../states/LanguajeStates';
import * as UserState from '../states/UserState';
import * as AuthState from '../states/AuthUserState';
import * as ProceduresState from '../states/ProceduresState';
import * as PractitionerProtocolVisitsState from '../states/PractitionerProtocolVisitsState';
import * as ProtocolVisitsState from '../states/ProtocolVisitsState';
import * as ProtocolPatientsState from '../states/ProtocolPatientsState';
import * as CashFlowPaymentsState from '../states/CashFlow.Payment.State';
import * as CashFlowPaymentImputationsState from '../states/CashFlow.PaymentImputations.State';
import * as CashFlowAccountsState from '../states/CashFlow.Account.State';
import * as CashFlowAccountMovementsState from '../states/CashFlow.AccountMovement.State';
import * as CashFlowDebtsState from '../states/CashFlow.Debt.State';
import * as CashFlowDebtMovementsState from '../states/CashFlow.DebtMovement.State';
import * as CashFlowStatisticsState from '../states/CashFlow.Statistics.State';
import * as SpecialtiesState from '../states/Specialties.State';
import * as SnomedState from '../states/Snomed.State';
import * as StaffState from '../states/StaffState';
import * as PersonState from '../states/PersonState';
import * as PersonAddressState from '../states/PersonAddressState';
import * as PersonEmailState from '../states/PersonEmailState';
import * as PersonPhoneState from '../states/PersonPhoneState';
import * as PersonIdentifierState from '../states/PersonIdentifierState';
import * as PersonIdentifierTypeState from '../states/PersonIdentifierTypeState';
import * as PersonPreferenceState from '../states/PersonPreferenceState';
import * as PersonRelationshipState from '../states/PersonRelationshipState';
import * as PersonRelationshipTypeState from '../states/PersonRelationshipTypeState';
import * as PersonExternalAssociationState from '../states/PersonExternalAssociationState';
import * as FileUploadState from '../states/FileUploadState'; 
import * as VisitConceptState from '../states/VisitConceptsState';
import * as ContractConceptRelationshipState from '../states/ContractConceptRelationship.State';
import * as ContractIAImportState from '../states/Contract.IAImport.States';
import * as ProtocolConsumptionSyncAnalysisState from '../states/ProtocolConsumptionSyncAnalysis.States';
import * as ConsumerState from '../states/ConsumerState';
import * as ServiceState from '../states/ServiceState';
import * as ServiceCategoryState from '../states/ServiceCategoryState';
import * as ContractBranchState from '../states/ContractBranchState';
import * as ConceptState from '../states/ConceptState';
import * as ConceptCategoryState from '../states/ConceptCategoryState';
import ConceptReducer from './ConceptReducer';
import ConceptCategoryReducer from './ConceptCategoryReducer';
import { TurneroState } from '../states/Turnero.State';

export interface AppState {
  readonly MedicalInsurances:
    | medicalInsuranceState.MedicalInsuranceState
    | undefined;
  readonly MedicalInsurancePlans:
    | medicalInsurancePlansState.MedicalInsurancePlanState
    | undefined;
  readonly MedicalInsuranceAgreements:
    | medicalInsuranceAgreementsState.MedicalInsuranceAgreementsState
    | undefined;
  readonly MedicalServices:
    | medicalServicesState.AvailableMedicalServiceState
    | undefined;
  readonly Configuration: configurationState.ConfigurationState | undefined;
  readonly PriceDetails: priceDetailsState.PriceListDetailsState | undefined;
  readonly PriceList: priceListState.PriceListState | undefined;
  readonly PractitionerContracts:
    | practitionerContractsState.PractitionerContractState
    | undefined;
  readonly TenantPriceLists:
    | tenantPriceListsState.TenantPriceListState
    | undefined;
  readonly AgreementServices:
    | agreementServiceState.AgreementServicesState
    | undefined;
  readonly Practitioners: PractitionerState.PractitionerState | undefined;
  readonly Provider: ProviderState.ProviderState | undefined;
  readonly ProviderMedicalServiceAssociations: ProviderMedicalServiceAssociationState.ProviderMedicalServiceState;
  readonly ProviderPriceListAssociations: ProviderPriceListAssociationState.ProviderPriceListState;
  readonly Sponsor: SponsorState.SponsorState | undefined;
  readonly AgreementServiceDetails:
    | AgreementServiceDetailsState.AgreementServiceDetailsState
    | undefined;
  readonly PractitionerMedicalInsuranceAssociations:
    | PractitionerMedicalInsuranceAssociationsState.PractitionerMedicalInsuranceState
    | undefined;
  readonly PractitionerSpecialtyAssociations:
    | PractitionerSpecialtyAssociationsState.PractitionerSpecialtyAssociationState
    | undefined;
  readonly PractitionerMedicalServiceAssociations:
    | PractitionerMedicalServiceAssociationsState.PractitionerMedicalServiceState
    | undefined;
  readonly PractitionerSettings:
    | PractitinerSettingsState.PractitionerSettingsState
    | undefined;
  readonly ProfessionalAvailability:
    | ProfessionalAvailabilityState.ProfessionalAvailabilityState
    | undefined;
  readonly MedicalProtocols:
    | MedicalProtocolState.MedicalProtocolsState
    | undefined;
  readonly Contract: ContractState.ContractState | undefined;
  readonly ContractAccess: ContractAccessState.ContractAccessState | undefined;
  readonly ContractAddendum: ContractAddendumState.ContractAddendumState | undefined;
  readonly ContractConcept: ContractConceptState.ContractConceptState | undefined;
  readonly ContractConceptConcept: ContractConceptConceptState.ContractConceptConceptState | undefined;
  readonly ContractConceptPaymentSchedule: ContractConceptPaymentScheduleState.ContractConceptPaymentScheduleState | undefined;
  readonly ContractStage: ContractStageState.ContractStageState | undefined;
  readonly ContractStageType: ContractStageTypesState.ContractStageTypeState | undefined;
  readonly ContractStageCycle: ContractStageCycleState.ContractStageCycleState | undefined;
  readonly ContractBranch: ContractBranchState.ContractBranchState | undefined;
  // Contract sub-slices consolidated under Contract
  readonly Settlement: SettlementState.SettlementState | undefined;
  readonly ProtocolPractitioners: ProtocolPractitionerState.ProtocolPractitionersState | undefined;
  readonly Language: LanguajeState.LanguajeState | undefined;
  readonly UserSettings: UserState.CurrentUserState | undefined;
  readonly oidc: AuthState.AuthUserState | undefined;
  readonly Procedures: ProceduresState.ProceduresState | undefined;
  readonly ContractCommissionConcept: ContractState.ContractState | undefined;
  readonly ContractCommissionAgent: ContractState.ContractState | undefined;
  readonly ContractCommissionAgentConcept: ContractState.ContractState | undefined;
  // Contract commission slices consolidated under Contract
  readonly PractitionerProtocolVisits: PractitionerProtocolVisitsState.PractitionerProtocolVisitsState | undefined;
  readonly ProtocolVisits: ProtocolVisitsState.ProtocolVisitsState | undefined;
  readonly ProtocolPatients: ProtocolPatientsState.ProtocolPatientsState | undefined;
  // Contract commission agent concept consolidated under Contract
  readonly CashFlowPayments: CashFlowPaymentsState.CashFlowPaymentState | undefined;
  readonly CashFlowPaymentImputations: CashFlowPaymentImputationsState.CashFlowPaymentImputationsState | undefined;
  readonly CashFlowAccounts: CashFlowAccountsState.CashFlowAccountState | undefined;
  readonly CashFlowAccountMovements: CashFlowAccountMovementsState.CashFlowAccountMovementState | undefined;
  readonly CashFlowDebts: CashFlowDebtsState.CashFlowDebtState | undefined;  readonly CashFlowDebtMovements: CashFlowDebtMovementsState.CashflowDebtMovementState | undefined;
  readonly CashFlowStatistics: CashFlowStatisticsState.CashFlowStatisticsState | undefined;
  readonly Specialties: SpecialtiesState.SpecialtiesState | undefined;
  readonly Snomed: SnomedState.SnomedState | undefined;
  readonly Persons: PersonState.PersonState | undefined;
  readonly Staff: StaffState.StaffState | undefined;
  readonly PersonAddresses: PersonAddressState.PersonAddressState | undefined;
  readonly PersonEmails: PersonEmailState.PersonEmailState | undefined;
  readonly PersonPhones: PersonPhoneState.PersonPhoneState | undefined;
  readonly PersonIdentifiers: PersonIdentifierState.PersonIdentifierState | undefined;
  readonly PersonIdentifierTypes: PersonIdentifierTypeState.PersonIdentifierTypeState | undefined;
  readonly PersonPreferences: PersonPreferenceState.PersonPreferenceState | undefined;
  readonly PersonRelationships: PersonRelationshipState.PersonRelationshipState | undefined;
  readonly PersonRelationshipTypes: PersonRelationshipTypeState.PersonRelationshipTypeState | undefined;
  readonly PersonExternalAssociations: PersonExternalAssociationState.PersonExternalAssociationState | undefined;
  readonly Users: UserState.UserState | undefined;
  readonly FileUpload: FileUploadState.FileUploadState | undefined;
  readonly VisitConcepts: VisitConceptState.VisitConceptsState | undefined;
  readonly ContractConceptRelationship: ContractConceptRelationshipState.ContractConceptRelationshipState | undefined;
  readonly ContractIAImport: ContractIAImportState.ContractIAImportState | undefined;
  readonly ProtocolConsumptionSyncAnalysis: ProtocolConsumptionSyncAnalysisState.ProtocolConsumptionSyncAnalysisState | undefined;
  readonly Consumers: ConsumerState.ConsumerState | undefined;
  readonly Services: ServiceState.ServiceState | undefined;
  readonly ServiceCategories: ServiceCategoryState.ServiceCategoryState | undefined;
  readonly Concepts: ConceptState.ConceptState | undefined;
  readonly ConceptCategories: ConceptCategoryState.ConceptCategoryState | undefined;
  readonly Turnero: TurneroState | undefined;
}

export const reducers = {
  MedicalInsurances: medicalInsurances.MedicalInsuranceReducer,
  MedicalInsurancePlans: medicalInsurancePlans.MedicalInsurancePlansReducer,
  MedicalServices: medicalServices.MedicalServicesReducer,
  MedicalInsuranceAgreements: medicalInsuranceAgreements.MedicalInsuranceAgreementsReducer,
  Configuration: configuration.ConfigurationReducer,
  PriceList: priceList.PriceListDetailsReducer,
  PriceDetails: priceDetails.PriceListDetailsReducer,
  PractitionerContracts: practitionerContracts.PractitionerContractReducer,
  TenantPriceLists: tenantPriceLists.TenantPriceListReducer,
  AgreementServices: agreementServices.AgreementServiceReducer,
  Practitioners: Practitioner.CombinedPractitionerReducer,
  Provider: Provider.ProviderReducer,
  ProviderMedicalServiceAssociations:
    ProviderMedicalServiceAssociation.ProviderMedicalServiceAssociationReducer,
  ProviderPriceListAssociations:
    ProviderPriceListAssociation.ProviderPriceListAssociationReducer,
  Sponsor: Sponsor.SponsorReducer,
  AgreementServiceDetails:
    AgreementServiceDetails.AgreementServiceDetailsReducer,
  PractitionerSpecialtyAssociations:
    PractitionerSpecialtyAssociations.PractitionerSpecialtyAssociationReducer,
  PractitionerMedicalInsuranceAssociations:
    PractitionerMedicalInsuranceAssociations.PractitionerMedicalInsuranceAssociationReducer,
  PractitionerMedicalServiceAssociations:
    PractitionerMedicalServiceAssociations.PractitionerMedicalServiceAssociationReducer,
  PractitionerSettings: PractitionerSettingsReducer.PractitionerSettingsReducer,
  ProfessionalAvailability:
    ProfessionalAvailabilityReducer.ProfessionalAvailabilityReducer,
  MedicalProtocols: MedicalProtocolReducer.CombinedMedicalProtocolReducer,
  // MedicalProtocolsConsumptionVisit:
  //   MedicalProtocolsConsumptionVisitReducer.MedicalProtocolsConsumptionVisitReducer,
  Contract: ContractCombine.CombinedContractReducer,
  ContractAccess: require('./ContractReducer/Contract.Access.Status.Reducer').default,
  ContractAddendum: require('./ContractReducer/Contract.Addendums.Reducer').default,
  ContractConcept: ContractConceptReducer.CombinedContractConceptReducer,
  ContractConceptConcept: require('./ContractReducer/Contract.ConceptConcepts.Reducer').default,
  ContractConceptPaymentSchedule: require('./ContractReducer/Contract.ConceptPaymentSchedule.Reducer').default,
  // Keep legacy slices mapped to their reducers to satisfy AppState shape
  ContractStage: require('./ContractReducer/Contract.StagesByContract.Reducer').default,
  // Stage types: if dedicated reducer doesn't exist, fall back to combined contract reducer
  ContractStageType: require('./ContractReducer/Contract.StageTypes.Reducer').default,
  ContractBranch: ContractBranchReducer.CombinedContractBranchReducer,
  ContractStageCycle: ContractStageCyclesReducer.default,
  // Contract sub-slices are managed within Contract reducer now
  // ContractStageType slice remains if its reducer is present
  Settlement: SettlementReducer.CombinedPractitionerReducer,
  ProtocolPractitioners: ProtocolPractitionerReducer.ProtocolPractitionersReducer,
  Language: LanguageReducer.LanguajeReducer,
  UserSettings: UserSettingsReducer.UserSettingsReducer,
  oidc: oidcAuthReducer,
  Procedures: ProceduresReducer.ProceduresReducer,
  ContractCommissionConcept: ContractCombine.CombinedContractReducer,
  ContractCommissionAgent: ContractCombine.CombinedContractReducer,
  ContractCommissionAgentConcept: ContractCommissionAgentConceptReducer,
  // Contract commission slices are handled within the Contract reducer
  PractitionerProtocolVisits: PractitionerProtocolVisitsReducer.PractitionerProtocolVisitsReducer,
  ProtocolVisits: ProtocolVisitsReducer.ProtocolVisitsReducer,
  ProtocolPatients: ProtocolPatientsReducer.ProtocolPatientsReducer,
  CashFlowPayments: CashFlowPaymentsReducer.CashFlowPaymentsReducer,
  CashFlowPaymentImputations: CashFlowPaymentImputationsReducer.CashFlowPaymentImputationsReducer,
  CashFlowAccounts: CashFlowAccountsReducer.CashFlowAccountsReducer,
  CashFlowAccountMovements: CashFlowAccountMovementsReducer.CashFlowAccountMovementsReducer,
  CashFlowDebts: CashFlowDebtsReducer.CashFlowDebtsReducer,  CashFlowDebtMovements: CashFlowDebtMovementsReducer.CashFlowDebtMovementsReducer,
  CashFlowStatistics: CashFlowStatisticsReducer.CashFlowStatisticsReducer,
  Specialties: SpecialtiesReducer.SpecialtiesReducer,
  Snomed: SnomedReducer.SnomedReducer,
  Persons: PersonsReducer.PersonsReducer,
  Staff: StaffReducer.StaffReducer,
  PersonAddresses: PersonAddressesReducer.PersonAddressesReducer,
  PersonEmails: PersonEmailsReducer.PersonEmailsReducer,
  PersonPhones: PersonPhonesReducer.PersonPhonesReducer,
  PersonIdentifiers: PersonIdentifiersReducer.PersonIdentifiersReducer,
  PersonIdentifierTypes: PersonIdentifierTypesReducer.PersonIdentifierTypesReducer,
  PersonPreferences: PersonPreferencesReducer.PersonPreferencesReducer,
  PersonRelationships: PersonRelationshipsReducer.PersonRelationshipsReducer,
  PersonRelationshipTypes: PersonRelationshipTypesReducer.PersonRelationshipTypesReducer,
  PersonExternalAssociations: PersonExternalAssociationsReducer.PersonExternalAssociationsReducer,
  Users: UserReducer.UserReducer,
  FileUpload: fileUploadReducer.FileUploadReducer,
  VisitConcepts: visitConceptsReducer.visitConceptsReducer,
  ContractConceptRelationship: ContractConceptRelationship.CombinedContractConceptRelationshipReducer,
  ContractIAImport: ContractIAImportReducer.CombinedContractIAImportReducer,
  ProtocolConsumptionSyncAnalysis: ProtocolConsumptionSyncAnalysisReducer,
  Consumers: ConsumerBaseReducer,
  Services: ServiceBaseReducer,
  ServiceCategories: ServiceCategoryBaseReducer,
  Concepts: ConceptReducer,
  ConceptCategories: ConceptCategoryReducer,
  Turnero: TurneroReducer.CombinedTurneroReducer,
};

export type AppThunkAction<TAction> = (
  dispatch: (action: TAction) => void,
  getState: () => AppState
) => void;
